export const READ = 'les';
export const CREATE = 'opprett';
export const EDIT = 'endre';
export const DELETE = 'slett';

export const ADMIN = 'cleos-admin';
export const ACCOUNTCODEPLAN = 'cleos-account-code-plan';
export const CLEARING = 'cleos-clearing';
export const SETTLEMENTS = 'cleos-settlements';
export const MONITORING = 'cleos-monitoring';
export const REPORTS = 'cleos-reports';
export const REPORTINGSTATUS = 'cleos-reporting-status';
export const REGISTER = 'cleos-register';
export const ACCOUNTINGMAPPING = 'cleos-accounting-mapping';

export const getPermission = (operation: string, right: string) => `${operation}.${right}`;
